<template>
  <div class="splashScreen">
    <div
      class="logo"
      :class="{ 'younesis': isYounesisProject, 'bodybase': isBodybaseProject }"
      :style="{ backgroundImage: store.state.app?.appIcons?.logoBgUrl186x84 }"
    />
  </div>
</template>

<script setup>
import store from '@/store/store.js'

import {computed} from "vue";
const isYounesisProject = computed(() => store.getters['app/isYounesisProject'])
const isBodybaseProject = computed(() => store.getters['app/isBodybaseProject'])
</script>

<style lang="scss" scoped>

.splashScreen {
  background-color: var(--app-background-color);
  position: absolute;
  top: 0;
  width: 100%;
  height: 100svh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 101;
}

.logo {
  display: block;
  height: var(--logo-splash-height, 84px);
  width: var(--logo-splash-width, 186px);
  position: relative;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;

  &.bodybase::after,
  &.younesis::after {
    content: "";
    width: 300px;
    height: 70px;
    filter: blur(100px);
    transform: translate3d(0, 0, 0);
    background: rgb(207, 46, 46);
    opacity: 0.5;
    position: absolute;
    top: 5px;
    left: -50px;
  }
}

img {
  user-select: none;
}
</style>
